import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDischargeField } from "../../../../Redux/actions/dischargeActions";

const CONDITIONS = [
  { id: "COND001", desc: "Stable" },
  { id: "COND002", desc: "Improved" },
  { id: "COND003", desc: "Critical" },
  { id: "COND004", desc: "Referred" },
];

export default function ConditionAtDischarge() {
  const dispatch = useDispatch();
  const conditionDesc = useSelector(
    (state) => state.discharge?.conditionDesc || "Stable"
  );
  const conditionRemarks = useSelector(
    (state) => state.discharge?.conditionRemarks || ""
  );

  const handleConditionChange = (cond) => {
    dispatch(setDischargeField("conditionId", cond.id));
    dispatch(setDischargeField("conditionDesc", cond.desc));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-3 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        6. Condition at Discharge
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="flex flex-col gap-2.5">
          {CONDITIONS.map((cond) => (
            <label
              key={cond.id}
              className="flex items-center gap-2 cursor-pointer text-sm"
            >
              <input
                type="radio"
                name="condition"
                checked={conditionDesc === cond.desc}
                onChange={() => handleConditionChange(cond)}
                className="w-4 h-4 text-teal-600 focus:ring-teal-500 border-gray-300"
              />
              <span
                className={
                  conditionDesc === cond.desc
                    ? "font-semibold text-teal-800"
                    : "text-gray-700"
                }
              >
                {cond.desc}
              </span>
            </label>
          ))}
        </div>
        <div className="flex flex-col justify-end">
          <label className="block text-xs font-semibold mb-1 text-gray-700">
            Condition Remarks
          </label>
          <input
            type="text"
            value={conditionRemarks}
            onChange={(e) =>
              dispatch(setDischargeField("conditionRemarks", e.target.value))
            }
            className="w-full text-xs border border-gray-200 rounded-md px-3 py-2 outline-none focus:border-teal-500 transition"
            placeholder="e.g. Patient is clinically stable and fit for discharge."
          />
        </div>
      </div>
    </div>
  );
}
